// extracted by mini-css-extract-plugin
export var button = "styles-module--button--d1801";
export var description = "styles-module--description--2edeb";
export var events = "styles-module--events--a2e59";
export var eventsTable = "styles-module--eventsTable--6f560";
export var icon = "styles-module--icon--1b24e";
export var link = "styles-module--link--8ade7";
export var title = "styles-module--title--f8f27";